<template>
    <div>
        <div class="detailsinfoclaim">
          <span class="sub-title-header">{{title}}</span>
        </div>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_FIRST_NAME_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{contact.firstName}}
                </v-flex>
        </v-layout>
         <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_LAST_NAME_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{contact.lastName}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_MAIL_ADDRESS_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{contact.email}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_MOBILE_NUMBER_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{contact.mobilePhone}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_OFFICE_NUMBER_FIELD_NAME')}} : </v-label>
                </v-flex>
                <v-flex xs6>
                    {{contact.officePhone}}
                </v-flex>
        </v-layout>
    </div>
</template>
<script>
export default {
  props: ['contact', 'title']
}
</script>
